export default __webpack_public_path__ + "static/media/BiteYourLip-v3.efd91693.mp3";